function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/TOOLS/ico-30-text-minor");

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M9.032,19.376 L10.328,16.904 L13.58,16.904 L13.892,19.376 L14.888,19.376 L13.76,11 L12.476,11 L8,19.376 L9.032,19.376 Z M13.484,16.04 L10.772,16.04 L12.908,11.924 L12.968,11.924 L13.484,16.04 Z M18.056,19.52 C18.512,19.52 18.896,19.402 19.208,19.166 C19.52,18.93 19.804,18.552 20.06,18.032 L20.06,18.032 L20.096,18.032 L20.036,18.308 C20.012,18.428 20,18.536 20,18.632 C20,18.856 20.066,19.036 20.198,19.172 C20.33,19.308 20.532,19.376 20.804,19.376 L20.804,19.376 L21.632,19.376 L21.788,18.56 L20.912,18.56 L21.992,13.184 L21.068,13.184 L20.864,14.192 L20.816,14.192 C20.768,14 20.692,13.832 20.588,13.688 C20.484,13.544 20.36,13.424 20.216,13.328 C20.072,13.232 19.912,13.16 19.736,13.112 C19.56,13.064 19.38,13.04 19.196,13.04 C18.684,13.04 18.238,13.168 17.858,13.424 C17.478,13.68 17.164,14.01 16.916,14.414 C16.668,14.818 16.482,15.262 16.358,15.746 C16.234,16.23 16.172,16.7 16.172,17.156 C16.172,17.892 16.344,18.47 16.688,18.89 C17.032,19.31 17.488,19.52 18.056,19.52 Z M18.296,18.68 C17.912,18.68 17.62,18.552 17.42,18.296 C17.22,18.04 17.12,17.7 17.12,17.276 C17.12,17.092 17.14,16.888 17.18,16.664 L17.18,16.664 L17.36,15.764 C17.48,15.164 17.704,14.7 18.032,14.372 C18.36,14.044 18.776,13.88 19.28,13.88 C19.552,13.88 19.784,13.92 19.976,14 C20.168,14.08 20.32,14.186 20.432,14.318 C20.544,14.45 20.616,14.602 20.648,14.774 C20.68,14.946 20.676,15.128 20.636,15.32 L20.636,15.32 L20.384,16.58 C20.32,16.884 20.226,17.156 20.102,17.396 C19.978,17.636 19.812,17.86 19.604,18.068 C19.42,18.26 19.224,18.41 19.016,18.518 C18.808,18.626 18.568,18.68 18.296,18.68 Z",
  id: "path-1"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-2.9%",
  y: "-4.7%",
  width: "110.0%",
  height: "118.8%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.6,
  dy: 0.8,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
  type: "matrix",
  in: "shadowOffsetOuter1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/TOOLS/ico-30-text-minor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Aa"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#737475",
  xlinkHref: "#path-1"
}))));

const SvgIco30TextMinor = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30TextMinor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-text-minor.ce7c97d9.svg";
export { ForwardRef as ReactComponent };